const links = [
	{
		path: '/b2g-programmes/',
		home: true,
	},
	{
		path: '/b2g-programmes/format-programm-pod-zapros/',
		name: 'Формат программ под запрос',
		active: true,
	},
	{
		path: '/b2g-programmes/b2g-custom-programmes/',
		name: 'Открытые программы',
		active: true,
	},
	{
		path: '/b2g-programmes/b2g-cases/',
		name: 'Кейсы',
		active: false,
	},
	{
		path: '/b2g-programmes/metod-skolkovo/',
		name: 'Метод СКОЛКОВО',
		active: false,
	},
	{
		path: '/b2g-programmes/b2g-faculty/',
		name: 'Преподаватели и эксперты',
		active: false,
	},
];

export default links;
